module.exports = __webpack_public_path__ + "img/cargo.2862e8d.svg";